/* eslint-env browser, jquery */
/* globals GIG */

'use strict';

const UgcPhotosAbstract = require('./UgcPhotosAbstract');
const _ = require('underscore');
const trackingHubAdd = require('./tracking_hub_add');
const cleanUpUrlAfterRedirect = require('./clean_up_url_after_redirect');

const GALLERY_MAX_HEIGHT = 1000;

const MODAL_SINGLE_VIEW = '.single-view-modal';
const MODAL_GALLERY_VIEW = '.gallery-view-modal';

class UgcPhotosDesktop extends UgcPhotosAbstract {
  constructor(
    modalSelector = '#ugc-photos-modal',
    inlineSelector = '.ugc-photos',
    galleryOptions = {}
  ) {
    const gallerySelectors = _.extend(
      {
        galleryModal: `${modalSelector} .gallery-view-modal`,
        galleryLink: `${modalSelector} .open-ugc-gallery-modal`,
      },
      galleryOptions
    );

    super(modalSelector, inlineSelector, gallerySelectors);

    this.$helpfulButton = this.$modal.find('.helpful-btn');
    this.$helpfulButton.on('click', super.onHelpfulButtonClick.bind(this));
    this.HELPFUL_ACTIVE_CLASSES = 'c-bg-prim c-txt-white';

    if (this.model.get('hasMultipleImages')) {
      const $elem = this.$modal.find('.controls');

      this.$backwardControl = $elem.find('.back');
      this.$backwardControl.on(
        'click',
        this.onControlsClick.bind(this, 'back')
      );

      this.$forwardControl = $elem.find('.forward');
      this.$forwardControl.on(
        'click',
        this.onControlsClick.bind(this, 'forward')
      );
    }

    this.$modal.find('.report-link').on('click', () => this.openReportModal());
    this.reportModal.$el.on('click', this.closeReportModal.bind(this));
    this.reportModal.$reasons.on(
      'change',
      this.onReportReasonChange.bind(this)
    );
    this.reportModal.$el
      .find('form')
      .on('submit', this.onReportSubmit.bind(this));
    this.reportModal.$el
      .find('.modal-body')
      .on('click', event => event.stopPropagation());

    this.setupNotificationModal();

    this.galleryModal.$section.on(
      'scroll',
      this.debounced(this.onGalleryScroll)
    );

    // reset the height each time the img changes
    const $singleViewImg = this.$modal.find('.single-image img');
    $singleViewImg[0].onload = function() {
      const { naturalHeight, naturalWidth } = this;
      const naturalRatio = naturalHeight / naturalWidth;
      const newModalWidth = Math.min(
        $(`${modalSelector} .single-view-modal`).width(),
        naturalWidth
      );
      $singleViewImg.css('height', naturalRatio * newModalWidth);
    };

    this.helpfulFetchHandler.setHandlers({
      successHandlers: [this.setHelpfulButton.bind(this)],
    });

    cleanUpUrlAfterRedirect(/([?&](helpful|reportPhoto)=true.*)/);
    const openReportModalOnLoad = this.model.get('openReportModalOnLoad');
    if (openReportModalOnLoad) {
      this.fillSingleViewModal(openReportModalOnLoad.imageUuid);
      this.openSingleViewModal();
      this.openReportModal();
    }

    const openHelpfulModalOnLoad = this.model.get('openHelpfulModalOnLoad');
    if (openHelpfulModalOnLoad) {
      this.fillSingleViewModal(openHelpfulModalOnLoad.imageUuid);
      this.openSingleViewModal();
    }
  }

  setupReportModal() {
    const $reportModal = $('#ugc-report-photo-modal');
    this.reportModal = {
      $el: $reportModal,
      $reasons: $reportModal.find('#ugc-photo-report-dropdown'),
      $textarea: $reportModal.find('textarea'),
      $form: $reportModal.find('form'),
      $submitButton: $reportModal.find('button'),
      $closeIcon: $reportModal.find('.close-modal'),
    };

    this.reportModal.$textarea.on(
      'input',
      this.onReportTextareaChange.bind(this)
    );
    this.reportModal.$closeIcon.on('click', this.closeReportModal.bind(this));
  }

  setupNotificationModal() {
    this.$notificationModal = $('#ugc-notification-modal');

    this.$notificationModal
      .find('.close-modal')
      .on('click', this.closeNotificationModal.bind(this));

    this.$notificationModal.on('click', this.closeNotificationModal.bind(this));
    this.$notificationModal
      .find('.modal-body')
      .on('click', event => event.stopPropagation());
  }

  fillHeader({ postDate = '', username = '', userInitials = '' }) {
    this.$modal.find('.post-date').text(postDate);
    this.$modal.find('.name').text(username);
    this.$modal.find('.user-initials').text(userInitials);
  }

  fillGallery({ url, alt }) {
    const $modalImg = this.$modal.find('.single-image img');
    $modalImg.attr('src', '');
    $modalImg.attr('src', url);
    $modalImg.attr('alt', alt);
  }

  fillSingleViewModal(id) {
    const imageData = this.model.getImageData(id);
    if (!imageData) return;
    this.$modal.attr('data-active-id', id);
    this.fillGallery(imageData);
    this.fillHeader(imageData);
    super.setHelpfulState(id, imageData.helpfulState);
    this.setHelpfulButton(id);
  }

  onControlsClick(direction) {
    let newIndex;
    const currentIndex = this.model.getImageData(
      this.$modal.attr('data-active-id')
    ).index;

    const ids = this.model.ids();
    if (direction === 'back') {
      newIndex = currentIndex === 0 ? ids.length - 1 : currentIndex - 1;
    } else if (direction === 'forward') {
      newIndex = currentIndex === ids.length - 1 ? 0 : currentIndex + 1;
    }

    if (newIndex === undefined) return;

    this.fillSingleViewModal(ids[newIndex]);
    this.clearReportModal();

    if (direction === 'forward' && ids.length - newIndex < 2) {
      this.fetchGalleryImageUrls(this.currentCount);
    }
  }

  onImageClick(event) {
    const $el = $(event.currentTarget);
    if ($el.find('.view-all-images-overlay').length > 0) {
      this.openGalleryViewModal();
    } else {
      this.fillSingleViewModal($el.attr('data-id'));
      this.openSingleViewModal();
    }
  }

  onGalleryScroll() {
    super.onGalleryScroll(this.scrollPosition());
  }

  scrollPosition() {
    return (
      this.galleryModal.$section.scrollTop() +
      this.galleryModal.$section.height()
    );
  }

  onModalResizer(fun) {
    $(window).on('resize.ugcModalResizer', this.debounced(fun));
  }

  onModalResizerClose() {
    $(window).off('resize.ugcModalResizer');
  }

  setSingleViewModalMaxHeight() {
    const modalHeight = this.$modal.height();
    if (!this.singleViewModalHeightOffset) {
      this.singleViewModalHeightOffset = this.$modal
        .find('.single-view-header')
        .outerHeight();
    }
    const heightCalc = modalHeight - this.singleViewModalHeightOffset;
    this.$modal.find('.single-image img').css('max-height', `${heightCalc}px`);

    return heightCalc;
  }

  _showImageModal(modalSelector, resizerFun) {
    if (!window.GIG || !window.GIG.Modal) return;

    this.$modal
      .find(`${MODAL_SINGLE_VIEW}, ${MODAL_GALLERY_VIEW}`)
      .css('display', 'none');
    this.$modal.find(modalSelector).css('display', 'block');

    GIG.Modal.open({ el: this.$modal });
    GIG.Modal.onClose(this.onModalResizerClose, this.$modal.attr('id'), true);

    resizerFun.call(this);
    this.onModalResizer(resizerFun);
  }

  openSingleViewModal() {
    this._showImageModal(MODAL_SINGLE_VIEW, this.setSingleViewModalMaxHeight);
    this.clearReportModal();
    this._setupLeftRightArrowHandlers();
  }

  _setupLeftRightArrowHandlers() {
    $(document.body).on(
      'keyup.singleViewModal',
      (e => {
        if (
          this.reportModal.$el.hasClass('show-modal') ||
          this.$notificationModal.hasClass('show-modal')
        ) {
          return;
        } else if (e.key === 'ArrowLeft') {
          this.onControlsClick('back');
        } else if (e.key === 'ArrowRight') {
          this.onControlsClick('forward');
        }
      }).bind(this)
    );
    GIG.Modal.onClose(
      () => $(document.body).off('keyup.singleViewModal'),
      this.$modal.attr('id'),
      true
    );
  }

  getGalleryHeightOffset() {
    return (
      this.$modal.find('.gallery-view-modal header').outerHeight() +
      this.$modal.find('.gallery-view-modal footer').outerHeight()
    );
  }

  setGalleryMaxHeight() {
    const modalHeight = this.$modal.height();

    this.galleryViewModalHeightOffset = this.getGalleryHeightOffset();

    const maxHeight = modalHeight - this.galleryViewModalHeightOffset;

    this.galleryModal.$section.css(
      'max-height',
      `${Math.min(GALLERY_MAX_HEIGHT, maxHeight)}px`
    );

    return maxHeight;
  }

  openGalleryViewModal() {
    this._showImageModal(MODAL_GALLERY_VIEW, this.setGalleryMaxHeight);
  }

  closeReportModal(event) {
    if (event) {
      event.stopImmediatePropagation();
    }
    this.reportModal.$el.removeClass('show-modal');

    this._removeEscKeyHandler();
  }

  changeReportReason(reportUuid) {
    if (reportUuid) {
      this.reportModal.$reasons.val(reportUuid);
      this.onReportReasonChange();
    }
  }

  _addEscKeyHandler(fn) {
    this.$modal.data('closeonesckey', false);
    $(document.body).on('keyup.secondaryModal', e => {
      if (e.key === 'Escape') {
        fn(e);
      }
    });
  }

  _removeEscKeyHandler() {
    this.$modal.data('closeonesckey', true);
    $(document.body).off('keyup.secondaryModal');
  }

  openReportModal() {
    const imageId = this.$modal.attr('data-active-id');
    const imageData = this.model.getImageData(imageId);
    trackingHubAdd('UgcPhotosReportClick', {
      ugc_image_id: imageId,
      ugc_image_url: imageData.url,
    });

    this.reportModal.$el.addClass('show-modal');

    this._addEscKeyHandler(this.closeReportModal.bind(this));
  }

  onReportReasonChange() {
    const newReason = this.reportModal.$reasons.val();
    let shouldDisableButton = !newReason.length;

    if (newReason === this.model.get('otherReasonUuid')) {
      this.reportModal.$textarea.show();

      shouldDisableButton = !this.meetsMinimumTextareaLength();
    } else {
      this.reportModal.$textarea.hide();
    }

    this.reportModal.$submitButton.prop('disabled', shouldDisableButton);
  }

  clearReportModal() {
    this.reportModal.$reasons.val('');
    this.reportModal.$textarea.val('').hide();
    this.reportModal.$submitButton.prop('disabled', true);
  }

  onReportTextareaChange() {
    this.reportModal.$submitButton.prop(
      'disabled',
      !this.meetsMinimumTextareaLength()
    );
  }

  getReportModalReason() {
    return this.reportModal.$reasons.val();
  }

  onReportSuccess() {
    this.closeReportModal();
    this.openNotificationModal('report', true);
  }

  onAjaxError(type, isSuccess) {
    if (type === 'report') {
      this.closeReportModal();
    }
    this.openNotificationModal(type, isSuccess);
  }

  openNotificationModal(type, isSuccess = true) {
    this.$notificationModal
      .find('.ugc-notification-header, .ugc-notification-text')
      .hide();

    this.$notificationModal.find(`.ugc-notification-header.${type}`).show();
    const textClass = isSuccess ? 'success' : 'error';
    this.$notificationModal.find(`.ugc-notification-text.${textClass}`).show();

    this.$notificationModal.addClass('show-modal');

    this._addEscKeyHandler(this.closeNotificationModal.bind(this));
  }

  closeNotificationModal(event) {
    event.stopImmediatePropagation();
    this.$notificationModal.removeClass('show-modal');

    this._removeEscKeyHandler();
  }

  setHelpfulButton(arg) {
    this.setHelpfulCountText(arg);
    this.setHelpfulButtonViewState(arg);
  }

  setHelpfulCountText(arg) {
    const id = typeof arg === 'object' ? arg.id : arg;
    const count = super.setHelpfulCount(id);
    this.$helpfulButton.find('.helpful-count').text(`(${count})`);
  }

  setHelpfulButtonViewState(arg) {
    super.setHelpfulButtonViewState(arg);
  }

  _setHelpfulButtonView() {
    this.$helpfulButton.addClass(
      `${super.getHelpfulClass()} ${UgcPhotosAbstract.HELPFUL}`
    );
  }

  _setNotHelpfulButtonView() {
    this.$helpfulButton.removeClass(
      `${super.getHelpfulClass()} ${UgcPhotosAbstract.HELPFUL}`
    );
  }
}

module.exports = UgcPhotosDesktop;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/UgcPhotosDesktop.js